import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get user
function* getExternalUserSubUserHandlerSage(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "externalusersubuser", ...action.payload }),
		);
		yield put({
			type: types.GET_EXTERNAL_USER_SUB_USER_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EXTERNAL_USER_SUB_USER_ERROR,
			payload,
		});
	}
}

export function* getExternalUserSubUserWatcherSaga() {
	yield takeLatest(types.GET_EXTERNAL_USER_SUB_USER_START, getExternalUserSubUserHandlerSage);
}

/*
//create user
function* createExternalUserSubUserHandlerSage(action) {}

export function* createExternalUserSubUserWatcherSaga() {
	yield  takeLatest(
		types.CREATE_EXTERNAL_USER_SUB_USER_START,
		createExternalUserSubUserHandlerSage,
	);
}

//update user

function* updateExternalUserSubUserHandlerSage(action) {}

export function* updateExternalUserSubUserWatcherSaga() {
	yield  takeLatest(
		types.UPDATE_EXTERNAL_USER_SUB_USER_START,
		updateExternalUserSubUserHandlerSage,
	);
}
*/

//delete user

function* deleteExternalUserSubUserHandlerSage(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("externalusersubuser", action.payload),
		);
		yield put({
			type: types.DELETE_EXTERNAL_USER_SUB_USER_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_EXTERNAL_USER_SUB_USER_ERROR,
			payload,
		});
	}
}

export function* deleteExternalUserSubUserWatcherSaga() {
	yield takeLatest(
		types.DELETE_EXTERNAL_USER_SUB_USER_START,
		deleteExternalUserSubUserHandlerSage,
	);
}
